<template>
    <div v-if="isVisible">
        <div class="pl-4 pt-3 pb-4">
            <h5>Rebooking details</h5>
        </div>
        <v-row no-gutters>
            <v-col cols="12" class="px-2">                         
                <v-data-table dense 
                    :headers="getHeaders()"
                    :items="hoor" 
                    :disable-pagination=true hide-default-footer item-key="hoor_encrid">    
                    <template v-slot:item="hoor">
                    <tr> 
                        <td class="row-default">{{ $moment(hoor.item.hoor_dt).format("DD-MM-YYYY HH:mm") }}</td>
                        <td class="row-default">{{ hoor.item.hoor_oms }}</td>
                        <td class="row-default">{{ hoor.item.omst_display }}</td>
                        <td class="row-default">{{ hoor.item.gebr_naam }}</td>
                        <td class="row-default"><v-btn x-small text icon v-on:click="updHoor(hoor.item.hoor_encrid)"><v-icon small>mdi-wrench</v-icon></v-btn></td>
                        <td class="row-default">
                            <span v-if="hoor.item.can_delete">
                                <v-btn x-small text icon v-on:click="rmHoor(hoor.item.hoor_encrid)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn>
                            </span>
                            <span v-else> <!-- uitlijning knoppen andere regels -->
                                <v-btn x-small text icon disabled><v-icon small></v-icon></v-btn>
                            </span>
                        </td>
                    </tr>                                         
                    </template>   
                </v-data-table>                    
            </v-col>
        </v-row>
        <v-row dense>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn x-small text icon v-bind="attrs" v-on="on"
                           v-on:click="addHoor()"
                           class="mr-7 mb-2 gridbutton"><v-icon small>mdi-plus</v-icon>
                    </v-btn>
                </template>
                <span>Add new event for {{ this.key }} </span>
            </v-tooltip>                
        </v-row>
    </div>
</template>

<script>

export default {
    props: {
        isVisible: {
            type: Boolean,
            default: false
        },
    },          
    components: {    
    },
    data() {
        return {
            key: '',
            homb_encrid: '',
            hoor: [],
        }
    }, 
    methods: {
        open(homb_encrid, key){
            this.key = key  
            this.homb_encrid = homb_encrid
            this.$emit('updateField', {field: 'showDetails', value: !this.isVisible});
            if(!this.isVisible){
                this.getHoor(homb_encrid);
            }
        },
        getHoor(homb_encrid) {
            this.$axios
                .post("ares/json/ares/huov/homb/getHoor.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHoor"
                    },
                    getHoor: {
                        homb_encrid: homb_encrid,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.hoor = res.data.getHoor;
                    }
                });
        },
        updHoor(hoor_encrid) {
            this.$emit('executeFunction',  [
                {field: 'function', value: 'add_upd_rebooking_event'},  
                {field: 'encrid', value: this.homb_encrid},  
                {field: 'key', value: hoor_encrid}
            ]);        },      
        addHoor(){
            this.$emit('executeFunction',  [
                {field: 'function', value: 'add_upd_rebooking_event'},  
                {field: 'encrid', value: this.homb_encrid},  
                {field: 'key', value: ''}
            ]);
        },  
        rmHoor(hoor_encrid){
            this.$axios
                .post("ares/json/ares/huov/homb/rmHoor.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "rmHoor"
                    },
                    rmHoor: {
                        hoor_encrid: hoor_encrid
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.updateData();
                    }
                });   
        },      
        updateData(){
           this.$emit('updateData', 'refresh');
        },      
        getHeaders(){
            return [
                { text: "Date/time", sortable: false,  width: "18%"},
                { text: "Description", sortable: false, width: "50%"},
                { text: "Status", sortable: false, width: "20%"},
                { text: "User", sortable: false, width: "20%"},
                { sortable: false, align: "start", width: "5%"},
                { sortable: false, align: "start", width: "5%"},
            ];
        },
    }
}
</script>

<style scoped>
  .row-default {
    cursor: default;
    vertical-align: top;
    border-top: 5px solid transparent;    
    font-size: 14px !important;
  }  
  .gridbutton{
    border: 1px solid rgba(169, 169, 169, 1) !important;
  }
</style>